<template @keydown.esc="$emit('update:opened', false)">
  <sc-dialog
    v-if="opened && selectedQuestion"
    :is-narrow="true"
    :title="$t('questionnaireQuestion.uploadLater')"
  >
    <sc-flex :is-column="true">
      <sc-p class="mb-4">
        {{
          selectedQuestion.question_type === 'upload'
            ? $t('questionnaire.uploadLaterMessage')
            : $t('questionnaire.answerLaterMessage')
        }}
      </sc-p>
      <v-text-field
        type="date"
        :rules="rules.dueDate"
        required
        v-model="answerByDate"
        class="default-input"
        solo
      />
      <sc-alert v-if="isAfterDueDate && isThisYear" type="note">
        <sc-flex :is-column="true" :gap="8">
          <div>
            {{
              $t('questionnaireQuestion.confirmAfterDueDateDescription', {
                date: moment(dueDate).format('ll'),
              })
            }}
          </div>
          <sc-button-group>
            <sc-button
              @click="$emit('save-answer-later-by', answerByDate)"
              size="small"
              type="primary"
              >{{
                $t('questionnaireQuestion.confirmAfterDueDateCTA')
              }}</sc-button
            >
          </sc-button-group>
        </sc-flex>
      </sc-alert>
      <sc-alert v-else-if="!isThisYear" type="danger">
        {{ $t('questionnaireQuestion.uploadLaterDateTooLate') }}
      </sc-alert>
    </sc-flex>

    <!-- Slot: Footer -->
    <footer slot="footer">
      <sc-button-group>
        <sc-button
          @click="onAnswerLater()"
          type="primary"
          :is-disabled="isDisabled"
          >{{ $t('confirm') }}</sc-button
        >
        <sc-button @click="$emit('update:opened', false)" type="secondary">{{
          $t('cancel')
        }}</sc-button>
      </sc-button-group>
    </footer>
  </sc-dialog>
</template>

<script>
import { rules } from '@/constants/variables';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

export default {
  components: {},

  props: {
    opened: {
      type: Boolean,
      default: false,
    },

    selectedQuestion: {
      type: Object,
      default: () => {},
    },

    dueDate: {
      type: String,
      default: '',
    },
  },

  computed: {
    isDisabled() {
      return (
        this.isBeforeNow ||
        isEmpty(this.answerByDate) ||
        moment(this.dueDate) < moment(this.answerByDate)
      );
    },
    isAfterDueDate() {
      return (
        this.dueDate &&
        this.answerByDate &&
        moment(this.dueDate) < moment(this.answerByDate)
      );
    },
    isBeforeNow() {
      return this.answerByDate && moment(this.answerByDate) < moment();
    },
    isThisYear() {
      return (
        this.answerByDate &&
        moment().year() === moment(this.answerByDate).year()
      );
    },
  },
  data() {
    return {
      rules,
      answerByDate: moment()
        .add(1, 'week')
        .format('Y-MM-DD'),
    };
  },
  methods: {
    isEmpty,
    moment,
    onAnswerLater() {
      if (this.isDisabled) return;

      return this.$emit('save-answer-later-by', this.answerByDate);
    },
  },
};
</script>
